<template>
 <div Class="col-md-12">
  <ConsulteGrid :columns="rows" :data-source="dataSource" :actions="true" @on-change-data-row="rowChange">
   <template #header>
    <router-link :to="'/patrimonio/patbem/cadastro'" Class="btn btn-primary rounded-pill"
     style="margin-left: 10px;">
     <i Class="uil uil-plus" aria-hidden="true"></i>Cadastrar
    </router-link>
   </template>
   <template #botaoSelecionar="context">
    <button type="button" class="btn btn-outline-warning" @click="selecionarRegistro(context.row)">Editar</button>
   </template>
   <template #botaoHistorico="context">
    <button type="button" class="btn btn-outline-info" @click="abrirHistorico(context.row)">Histórico</button>
   </template>
  </ConsulteGrid>
 </div>
</template>
<script lang = "ts" >
import ConsulteGrid from "@/components/grid/ConsulteGrid.vue";
import { ConsulteGridColumnsModel } from "@/datasources/consulte-grid";
import { defineComponent } from "vue";
import PatBemDataSource from "@/datasources/patrimonio/patbem/index.datasource"
import { PatBemModel } from '@/models/patrimonio/patbem/patbem.model';
import servicoTipoBem from '@/services/patrimonio/pattipobem/pattipobem.service';

import router from '@/routes'

export default defineComponent({
 name:  "PatBemGridIndex",
 mounted() {
 },
 components: { ConsulteGrid },
 methods: {
  rowChange(value: String, row:  PatBemModel) {
   console.log(value);
   console.log(row);
   //chamar o serviço post e recarregar o grid
  },
  async selecionarRegistro(row:  PatBemModel) {
   await router.push({
    name: 'patbem_create',  // Nome da rota definido na configuração da rota
    params: { id: row.patBemId }           // Envia o parâmetro id como params
   });
  },
  async abrirHistorico(row: PatBemModel) {
   await router.push({
    name: 'patbem_historico',
    params: { patBemId: row.patBemId }
   });
  },
 },
 data() {
  return {
   dataSource:  new PatBemDataSource(0, 10, 0, 0, [], (dataSource: any) => {
    dataSource.rows.forEach((row: any) => {
     row._rowClass = Number(row.situacao) === 1 ? 'row-baixado' : '';
    });
   }),
   rows: [
    {
     text: "Selecionar",
     align: "center",
     cellsalign: "center",
     datafield: "botaoSelecionar",
     editable: false,
     filtertype: "text",
     filterable: false
    },
    {
     text: "Histórico",
     align: "center",
     cellsalign: "center",
     datafield: "botaoHistorico",
     editable: false,
     filtertype: "text",
     filterable: false
    },
    {
     text: "Tipo de Bem",
     hidden: true,
     align: "center",
     cellsalign: "center",
     datafield: "patTipoBemId",
     editable: false,
     visible: false, 
     filtertype: 'autocomplete',
     filterlistpromise: servicoTipoBem.DropDownList,
     filtervaluefield: 'valor',
     filtertextfield: 'texto',
     filtermode: 'single',
     conditionbetweenfilters: 'or',
     filterable: true
    },
    {
     text: "Código",
     align: "center",
     cellsalign: "center",
     datafield: "codigo",
     editable: false,
     filtertype: "text",
     filterable: true
    },
    {
     text: "Descrição",
     align: "center",
     cellsalign: "center",
     datafield: "descricao",
     editable: false,
     filtertype: "text",
     filterable: true
    },
    {
     text: "Tipo de Bem",
     align: "center",
     cellsalign: "center",
     datafield: "patTipoBemDescricao",
     editable: false,
     filtertype: "text",
     filterable: false
    },

    {
     text: "Sala",
     align: "center",
     cellsalign: "center",
     datafield: "salaDescricao",
     editable: false,
     filtertype: "text",
     filterable: false
    },
    {
     text: "Situacao",
     hidden: true,
     align: "center",
     cellsalign: "center",
     datafield: "situacao",
     editable: false,
     filtertype: "text",
     filterable: false
    },
       ] as ConsulteGridColumnsModel[],
  };
 }
});
</script>
<style scoped>
:deep(.row-baixado td) {
 color: #dc3545 !important;
}
</style>
